import { Tab, Tabs } from "@mui/material";

export type ChatInboxFilter = "all" | "unread";

interface ChatInboxFilterTabsProps {
  value: ChatInboxFilter;
  unreadCount: number;
  onChange: (value: ChatInboxFilter) => void;
}

export function ChatInboxFilterTabs(props: ChatInboxFilterTabsProps) {
  const { value, unreadCount, onChange } = props;

  return (
    <Tabs
      value={value}
      onChange={(_event, next: ChatInboxFilter) => onChange(next)}
      sx={{
        px: 2,
        minHeight: 40,
        borderBottom: 1,
        borderColor: "divider",
        "& .MuiTab-root": {
          minHeight: 40,
          textTransform: "none",
          fontWeight: 500,
          py: 1,
          px: 0,
          mr: 3,
          minWidth: 0,
        },
      }}
    >
      <Tab value="all" label="All" />
      <Tab value="unread" label={`Unread (${unreadCount})`} />
    </Tabs>
  );
}
